import { Edit, Delete } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { setRutaId,setDefaultData } from "store/modules/Rutas";
import { v4 as uuidv4 } from 'uuid';


export const columns = (setOpen, setMode,setOpenDelete, dispatch) => {
  return [{
    field: `${uuidv4()}`,
    headerName: "Acciones",
    width: 100,
    renderCell: (data) => (
      <React.Fragment>
        <Tooltip title="Editar Ruta" placement="top">
          <IconButton
            aria-label="edit"
            color="primary"
            onClick={() => { setOpen(true); setMode("PUT"); dispatch(setDefaultData(data.row));dispatch(setRutaId(data.row.id)) }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar Ruta" placement="top">
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() => { setOpenDelete(true); setMode("DELETE");dispatch(setRutaId(data.row.id)) }}
          >
            <Delete />
          </IconButton>
        </Tooltip>

      </React.Fragment>
    ),
  },
  {
    field: "codigo",
    headerName: "Código",
    width: 200,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    width: 200,
  },
  {
    field: "descripcion",
    headerName: "Descripción",
    width: 450
  },
  {
    field: 'region',
    headerName: "Región",
    width: 200,
  },
  {
    field: 'zona',
    headerName: "Zona",
    width: 150,
  },
  
]
}
